import withRouter from "../../../../withRouter";
import BaseListPage from "../../../../base/BaseListPage";
import AssignedUserPresenter from "./AssignedUserPresenter";
import { Button, Progress } from "nq-component";
import Table from "../../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import NavBar from "../../../../components/NavBar";
import CardView from "../../../../components/common/CardView";
import { FloatingForm } from "../../../../components/common/Converter";
import InputFactory from "../../../../components/InputFactory";

class AssignedUser extends BaseListPage {
  constructor(props) {
    super(props);
    this.state = { objects: [], count: 0, limit: 2000, current: 1, total: 0 };
    this.presenter = new AssignedUserPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const totalLength = await findObjectUseCase().execute(
      this.getCollectionName(),
      { where: { ...this.presenter.where }, keys: ["id"] },
    );
    this.setState({ total: totalLength.length });
  }
  getCollectionName() {
    return "users";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, limit, current } = this.state;
    console.log("BBBBBBB: ", objects);
    if (!schema) return <Progress />;
    const employeeAgencyField = {
      employeeAgencyNum: {
        type: "String",
        label: "Employee Agency #",
      },
    };
    console.log("objects: ", objects);

    // rebuild schema
    schema.fields = {
      ...employeeAgencyField,
      ...schema.fields,
    };
    return (
      <>
        <FloatingForm width={"80rem"}>
          <CardView>
            <div
              style={{
                marginTop: "20px",
                width: "100%",
              }}
            >
              <CardView style={{ borderRadius: 0 }}>
                <div className="d-flex align-items-center justify-content-between">
                  <h4 className="text-primary">Assigned Users</h4>
                  <h4 className="text-dark">COUNT: {this.state.total}</h4>
                </div>

                <div className="row">
                  <div className="d-flex mb-1 col-lg-10">
                    {Object.keys(schema.filters || {}).map((field) => {
                      let { type, ...options } = schema.filters[field];
                      return (
                        <InputFactory
                          key={field}
                          className="ms-1"
                          type={type}
                          field={field}
                          where={{}}
                          onChange={this.onChangeFilter.bind(this, type)}
                          {...options}
                        />
                      );
                    })}
                  </div>
                  <div className="col-lg-2 text-center">
                    <Button
                      onClick={() =>
                        this.presenter.handleExportToCSV(
                          objects,
                          "assignedUser",
                          schema,
                        )
                      }
                    >
                      export to CSV
                    </Button>
                  </div>
                </div>
              </CardView>
            </div>

            <Table
              // objectId={this.handleDeleteData.bind(this)}
              // editId={this.handleEditData.bind(this)}
              progress={loading}
              refetch={this.refetchData.bind(this)}
              fields={schema.fields}
              objects={objects}
              collection={schema}
              count={count}
              limit={limit}
              current={current}
              loadPagination={this.onClickPagination.bind(this)}
              // actionsList={[
              //   {
              //     label: <i className="bi bi-three-dots-vertical" />,
              //     actionType: "common",
              //   },
              // ]}
              // selectable
              // collapsable
              excludeFields={Object.keys(schema.fields).reduce(
                (acc, key) => {
                  const options = schema.fields[key];
                  if (options.read === false) {
                    acc.push(key);
                  }
                  switch (options._type || options.type) {
                    case "Relation":
                    case "Array":
                    case "Object":
                    case "File":
                      acc.push(key);
                      break;
                    default:
                  }
                  return acc;
                },
                ["id", "createdAt", "updatedAt", "status"],
              )}
              // selected={selected}
              // onSelect={this.onSelect.bind(this)}
              // onSelectAll={this.onSelectAll.bind(this)}
              // progress={progress}
              onClickItem={this.onClickItem.bind(this)}
            />

            <div style={{ marginLeft: "auto", marginTop: "2rem" }}>
              <button
                className="btn btn-danger"
                onClick={() => this.props.closeModal()}
              >
                Close
              </button>
            </div>
          </CardView>
        </FloatingForm>
      </>
    );
  }
}

export default AssignedUser;
